import React from "react";
import { withStyles } from "@material-ui/core/styles";
import IndexTable from "components/UI/DataTable/IndexTable";
import IndexLayout from "layouts/IndexLayout";
import moment from 'moment'

const moduleName = "schedulers";

const styles = () => ({
  root: {
    flexGrow: 1,
  },
});

class SchedulersIndex extends React.Component {
  render() {
    const { classes, schedulers, isLoading } = this.props;

    const today = new Date()

    console.warn(schedulers)
    let schedulersTemp = [];
    if(schedulers){
      let scheduler = schedulers.filter((value,index,array)=>{
        return (new Date(value.date.seconds * 1000) >= today)
      })

      schedulersTemp = scheduler.map((shed)=> {
       return {
        ...shed,
        date: moment(new Date(shed.date.seconds * 1000)).format('dddd, D MMMM YYYY'),
        time: moment(new Date(shed.date.seconds * 1000)).format('LT')
      };
    });
  }

    return (
      <div className={classes.root}>
        <IndexLayout moduleName="Upcoming Notifications">
          <IndexTable
            headers={headers}
            rows={schedulersTemp}
            moduleName={moduleName}
            isLoading={isLoading}
            actions={{
              edit: false,
              view: true
            }}
          />
        </IndexLayout>
      </div>
    );
  }
}

const headers = [
  { alias: "Date", key: "date" },
  { alias: "Time", key: "time"},
  { alias: "Customer", key: "customerName" },
  { alias: "Region", key: "regionName" },
  { alias: "Equipment", key: "equipmentName" },
  { alias: "Agreement", key: "agreementType" },

];

export default withStyles(styles)(SchedulersIndex);
